<mat-icon
  [svgIcon]="icon ? icon : 'mat_solid:close'"
  [class.invisible]="!icon || processing"
  [color]="color"
  [ngClass]="'icon-size-'+iconSize"
/>
@if (processing) {
  <div class="absolute inset-0 border-inherit bg-white bg-opacity-20">
    <mat-spinner class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" [diameter]="16" />
  </div>
}
